import sStorageWrapper from "@/api/local";

type PaginationFilters = {
  paginationLimit?: number;
  paginationLimitSecondary?: number;
};

export function getPaginationLimit(media: boolean = false): number {
  const storedFilters = (sStorageWrapper.getValue('filters') ?? {}) as PaginationFilters;
  const filterKey: keyof PaginationFilters = media ? 'paginationLimitSecondary' : 'paginationLimit';

  return storedFilters[filterKey] ?? 20;
}

export function savePaginationLimit(value: number = 20, media: boolean = false): void {
  const filterKey: keyof PaginationFilters = media ? 'paginationLimitSecondary' : 'paginationLimit';
  const storedFilters = (sStorageWrapper.getValue('filters') ?? {}) as PaginationFilters;

  storedFilters[filterKey] = value;
  sStorageWrapper.setValue('filters', storedFilters);
}

export function hasPaginationLimit(media: boolean = false): boolean {
  const storedFilters = (sStorageWrapper.getValue('filters') ?? {}) as PaginationFilters;
  const filterKey: keyof PaginationFilters = media ? 'paginationLimitSecondary' : 'paginationLimit';

  return storedFilters[filterKey] != undefined;
}